import { Component, Input } from '@angular/core';
import {AbstractInputDirective} from '../AbstractInputDirective';

@Component({
  selector: 'digires-percent-input',
  templateUrl: './percent-input.component.html',
  styleUrls: ['./percent-input.component.scss']
})
export class PercentInputComponent extends AbstractInputDirective {
  @Input() decimalPlaces: number = 0;
}
